import React from 'react';
import Box from '@amzn/meridian/box';
import Column from '@amzn/meridian/column';
import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';

interface VolumeTargetCardProps {
    label: string;
    targetValue: number | null;
    actualValue: number | null;
    overrideTargetValue?: number;
    overrideLabel?: string;
}

const VolumeTargetCard: React.FC<VolumeTargetCardProps> = ({
    label,
    targetValue,
    actualValue,
    overrideTargetValue,
    overrideLabel,
}) => {
    const hasData = targetValue != null && actualValue != null;
    const comparisonTarget = overrideTargetValue ?? targetValue ?? 0;
    const isAhead = hasData && actualValue >= comparisonTarget;

    return (
        <Box type="outline" spacingInset="400">
            <Column spacing="200">
                <Text type="h100" color="secondary">{label}</Text>
                <Row spacing="400" alignmentVertical="bottom">
                    <Column spacing="100">
                        <Text type="b200" color="secondary">Target</Text>
                        <Text type="h300">{hasData ? targetValue.toLocaleString() : '—'}</Text>
                    </Column>
                    {overrideTargetValue != null && (
                        <Column spacing="100">
                            <Text type="b200" color="secondary">{overrideLabel ?? 'Override'}</Text>
                            <Text type="h300">{overrideTargetValue.toLocaleString()}</Text>
                        </Column>
                    )}
                    <Column spacing="100">
                        <Text type="b200" color="secondary">Actual</Text>
                        <Text type="h300" color={!hasData ? 'secondary' : isAhead ? 'success' : 'error'}>
                            {hasData ? actualValue.toLocaleString() : '—'}
                        </Text>
                    </Column>
                </Row>
            </Column>
        </Box>
    );
};

export default VolumeTargetCard;
